<template>
    <div class="popup" :class="{active: show}">
        <div class="in">
            <div class="btn_close" @click="$emit('close')"></div>
            <img class="qrcode" :src="shareQrcode" alt=""/>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
    name: "shareToWX",
    props: ['show'],
    data() {
        return {};
    },
    computed: {
        ...mapState(['shareQrcode'])
    },
    components: {
        
    },
    mounted() {},
    watch: {},
    methods: {},
    destroyed() {},
};
</script>

<style scoped lang="scss">
.popup{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000, $alpha: 0.8);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    visibility: hidden;
    transition: opacity .3s, visibility .3s;
    &.active{
        opacity: 1;
        visibility: visible;
    }
    .in{
        width: 5.3rem;
        border-radius: .1rem;
        background: #fff;
        position: relative;
        padding: .4rem .55rem;
        .btn_close{
            width: .4rem;
            height: .4rem;
            border-radius: 50%;
            background: rgba($color: #000000, $alpha: 0.8);
            position: absolute;
            top: 0;
            right: -0.5rem;
            cursor: pointer;
            &::before,
            &::after{
                content: "";
                width: .2rem;
                height: .02rem;
                background: #fff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        .qrcode{

        }
    }
}
</style>